<!-- Container-fluid starts-->
<div class="container-fluid" >
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Channel List</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                    </div>
                    <div class="custom-datatable">
                        <form>
                            <div class="mb-3">
                              <!-- <input type='text' class="filter-ngx form-control" placeholder='Search...' [(ngModel)]="searchText"
                                autocomplete="off" /> -->
                            </div>
                          </form>
                        <button class="btn btn-primary me-1 mb-3" style="float: right;">Delete</button>
                        <div class="clearfix"></div>
                        <table class="table table-striped" >
                            <thead>
                                <tr>
                                    <th> </th>
                                    <th scope="col" sortable="id" (sort)="onSort($event)">Id</th>
                                    <th scope="col" sortable="channel_id" (sort)="onSort($event)">Channel Id</th>
                                    <th scope="col" sortable="name" (sort)="onSort($event)">Name</th>
                                    <th scope="col" sortable="country" (sort)="onSort($event)">Country Name</th>
                                  <!---  <th scope="col" sortable="status" (sort)="onSort($event)">Owned</th>-->
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let item of countryname | slice: (page-1) * pageSize : page * pageSize" >
                                    <th><input type="checkbox" name="title_select" onclick="onSelect(item.id)"></th>
                                    <th scope="row">{{ item.id }}</th>
                                    <th scope="row">{{ item.channel_id }}</th>
                                    <th scope="row">{{ item.name }}</th>
                                    <th scope="row">
                                         <p>{{item.country.country_name}}</p> 
                                        <p></p>
                                    </th>
   
                               <th scope="row"><a class="btn btn-primary" [routerLink]="['/pages/create-page/',item.channel_id]">Edit</a></th> 
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="d-flex justify-content-center p-2">
                            <!-- <ngb-pagination
                              [collectionSize]="(total$ | async)!" [(page)]="service.page" [pageSize]="service.pageSize">
                            </ngb-pagination> -->

                            <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="countryname.length"></ngb-pagination>
                            <!-- <ngb-pagination [collectionSize]="120" [(page)]="page" [maxSize]="5" [boundaryLinks]="true"></ngb-pagination> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Container-fluid Ends-->
